<template>
  <div>
    <input type="hidden" name="_token" :value="csrf" />
    <input v-if="this.editing" type="hidden" name="_method" value="PUT" />
    <div v-if="(permission_final_value >= 1 || permission_final_rating >= 1 ) && !empty_values" class="row px-3">
      <div v-if="permission_final_value >= 1" class="col-12 col-md-6 col-lg-6 mb-4">
        <div class="card p-2 border-card shadow">
          <p class="text-primary">
            {{ __("forms.EvaluationChart.results") }}
          </p>
          <p class="text-right h3">{{ finalValue || "&nbsp;" }}</p>
        </div>
      </div>

      <div v-if="permission_final_rating >= 1" class="col-12 col-md-6 col-lg-6 mb-4">
        <div class="card p-2 border-card shadow">
          <p class="text-primary">
            {{ __("forms.EvaluationChart.range") }}
          </p>
          <p class="text-right h3">{{ finalRating || "&nbsp;" }}</p>
        </div>
      </div>
    </div>
    <div class="custom-table-container px-4 mt-2">
      <table class="table table-custom-header">
        <thead>
          <tr>
            <th class="sticky-header sticky-col">{{ __("views.KPIAssociation.survey_question") }}</th>
            <th style="min-width:50px"
              class="matrix-center-element sticky-header"
              v-for="(answer, index_answer) in answers"
              :key="index_answer"
            >
              <span
                style="text-decoration: underline; cursor: pointer"
                @click="showColumnDeclaration(answer.declaration[locale])"
                >{{ answer.label[locale] }}</span
              >
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(question, index_q) in questions" :key="index_q">
            <th class="sticky-col">
              {{ question[locale] }}
            </th>
            <td style="min-width:50px"
              class="matrix-width matrix-center-element"
              v-for="(answer, index_a) in answers"
              :key="index_a"
            >
              <input
                v-if="permission_matrix > 1"
                type="radio"
                :class="'saveQuestion custom-radio ' + class_required"
                :value="answer.value"
                v-model="user_answers[index_q]"
                :name="'question[' + question_survey_id + '][' + index_q + ']'"
              />
              <div v-else>
                <label v-if="user_answers[index_q] == answer.value"> <i style="color: #2A9D8F" class="fa-solid fa-circle-check"></i></label>
                <label v-else></label>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="refreshAfterSaveAnswers" @click="getCalculationMatrixTable()"></div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.getCalculationMatrixTable();
  },
  props: {
    evaluation_chart_id: {
      type: Number,
      required: true,
    },
    question_survey_id: {
      type: Number,
      required: true,
    },
    permission_matrix: {
      type: Number,
      required: true,
    },

    permission_final_value: {
      type: Number,
      required: true,
    },
    permission_final_rating: {
      type: Number,
      required: true,
    },

    is_admin: {
      type: Boolean,
      required: true,
    },
    questions: {
      type: Array,
      required: true,
    },
    user_answers: {
      type: Array,
      required: true,
    },
    answers: {
      type: Array,
      required: true,
    },
    locale: {
      type: String,
      required: true,
    },
    class_required: {
      type: String,
      required: true,
    },
    switch_evaluation_recruiting: {
      type: String,
      required: false,
      default: "evaluationChart",
    },

    empty_values: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      userUrl: this.is_admin ? "" : "-user",
      finalRating: "",
      finalValue: null,
      //default

      action: "",
      editing: true,
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
    };
  },
  methods: {
    showColumnDeclaration(txt) {
      Vue.swal.fire({
        title: "",
        html: txt, 
      });
    },
    getCalculationMatrixTable() {
      let getUrl = "";
      switch (this.switch_evaluation_recruiting){
        case "evaluationChart":
          getUrl = "/matrix-calculation-chart" + this.userUrl +"/" +this.evaluation_chart_id +"/" +this.question_survey_id;
          break;
          case "recruitingChart":
            getUrl = "/matrix-calculation-recruiting-chart" +this.userUrl +"/" +this.evaluation_chart_id +"/" + this.question_survey_id;
          break;
          case "morphChart":
            getUrl = "/matrix-calculation-morph-chart" +this.userUrl +"/" +this.evaluation_chart_id +"/" + this.question_survey_id;
          break;
      }
      axios.get(getUrl).then((response) => {
        this.finalRating = response.data.finalRating[this.locale];
        this.finalValue = response.data.finalValue;
      });
    },
  },
};
</script>

<style scoped>
.custom-table-container {
  width: 100%;
  overflow-x: auto; /* Assicura lo scorrimento orizzontale */
}

table {
  width: 100%; /* Facoltativo, ma aiuta a controllare il layout */
  table-layout: auto !important;
  overflow-x: scroll !important;
  width: 100%;
}

.table-custom-header thead tr th {
  background: transparent;
  color: #1767A2 !important;
  font-weight: 800 !important;
}

.custom-table-container {
  padding-right: 20px;
  width: 100%;
  overflow-x: auto;
  max-height: 80vh; 
  overflow-y: auto; 
}

.custom-radio,
.custom-checkbox {
  width: 22px;
  height: 22px;
}

.sticky-col {
  position: -webkit-sticky;
  position: sticky;
  left: 0;
  background-color: white !important;
  z-index: 3;
  box-shadow: 2px 0 5px -2px rgba(0, 0, 0, 0.5); 
  min-width:200px !important;
}

.sticky-header {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  background-color: white !important;
  z-index: 2; 
}
</style>
